import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoStaria from "../staria/InfoStaria";
const Footer = lazy(() => import('../footer/Footer'));
function Staria() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hyundai Staria, tu compañero ideal, 100% Europeo. Galardonado por su seguridad, rendimiento, equipamiento, tecnología, amplitud y confort. Un VAN premium"
        />
        <meta
          name="keywords"
          content="Hyundai, vehículos, autos, VAN, Staria"
        />
        <title>Hyundai Staria</title>
      </Helmet>
      <Menu />
      <InfoStaria />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Staria;